import { ADRESS_STATUS_KEYS } from './adressStatusLabels';
import isAppointment from './taskKind';

/**
 * Mag een huisbezoek de status van zijn huishouden vooruitzetten naar
 * `targetStatus`?
 *
 * De gedeelde regel achter 'Automatisch Ingepland' en 'Automatisch Afgerond'.
 * Die twee zijn op één ding na identiek, en een kopie zou uit elkaar gaan lopen
 * zodra er een status bijkomt of de volgorde wijzigt.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * **Alleen VOORUIT.** 'Vooruit' komt uit de trechtervolgorde in
 * `ADRESS_STATUS_KEYS` en niet uit een eigen lijst statussen die mee mogen —
 * precies dat ging eerder mis toen 'In afwachting' tussen 'Inplannen' en
 * 'Ingepland' werd geschoven en een hardgecodeerde lijst stil de verkeerde
 * huishoudens oversloeg.
 *
 * Gevolg voor 'Afgerond': een huishouden op 'Onbereikbaar' blijft staan, want
 * die staat in de trechter ná 'Afgerond'.
 *
 * Een onbekende status laat het huishouden met rust: wat we niet kunnen plaatsen
 * in de trechter, weten we ook niet vooruit te zetten.
 *
 * @param {object|null|undefined} task - Het opgeslagen taakdocument
 * @param {string|null|undefined} currentStatus - De huidige Adresses.Status
 * @param {string} targetStatus - Waarheen, bijv. 'planned' of 'completed'
 * @returns {boolean}
 */
const advanceAdressStatus = (task, currentStatus, targetStatus) => {
    // isAppointment, niet Type: een subtaak mag de status van zijn huishouden
    // nooit vooruitzetten. AI-CONTEXT: See docs/features/subtaken-bij-het-huishouden.md
    if (!isAppointment(task)) return false;
    if (!task.AdressID) return false;
    if (!task.Timestamp) return false;

    const target = ADRESS_STATUS_KEYS.indexOf(targetStatus);
    if (target < 0) return false;

    // Nog geen status: dan is elke stap vooruit.
    if (!currentStatus) return true;

    const current = ADRESS_STATUS_KEYS.indexOf(currentStatus);
    if (current < 0) return false;

    return current < target;
};

export default advanceAdressStatus;
